/**
 * useTranslation Hook
 *
 * Custom hook that wraps react-i18next's useTranslation
 * to ensure it uses our initialized i18n instance.
 */

import { useTranslation as useReactI18nextTranslation } from 'react-i18next';
import { i18n } from '../config/shared';

/**
 * useTranslation hook
 *
 * Wrapper around react-i18next's useTranslation that ensures
 * the correct i18n instance is used.
 */
export function useTranslation(ns?: string | string[]) {
  return useReactI18nextTranslation(ns, { i18n });
}

export default useTranslation;
